import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SimpleForm,
  Create,
  Edit,
  Show,
  SimpleShowLayout,
  FunctionField,
  translate as t,
  ReferenceArrayInput,
  SelectInput,
} from 'admin-on-rest';
import {
  List as MaterialList,
  ListItem,
  FlatButton,
  Divider,
} from 'material-ui';

import CreateIcon from 'material-ui/svg-icons/content/add';
import EditIcon from 'material-ui/svg-icons/content/create';
import MenuListItemLink from '../components/MenuListItemLink';
import { getTranslationByLocale } from '../utils/TranslationUtils';
import '../styles/model/chapter/styles.css';
import UrlParamsLinkButton from '../components/button/UrlParamLinkButton';
import EditButton from '../components/button/EditButton';
import SelectArrayInput from '../components/inputs/SelectArrayInput';
import ReferenceInput from '../components/inputs/ReferenceInput';
import CourseMomentsInput from '../components/inputs/CourseMomentsInput';
import RichTextInput from '../components/inputs/RichTextInput';


const anchorStyle = {
  float: 'right',
  textAlign: 'center',
};

const styles = {
  NestedListItem: {
    backgroundColor: 'rbga(0,0,0,0)',
    transition: 'none',
  },
  Button: {
    display: 'inline-block',
  },
  Icons: {
    color: 'red',
  },
  PseudoNavButtons: {
    backgroundColor: 'red',
  },
  sectionMargin: {
    marginBottom: '40px',
  },
};

export const CourseList = t((props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="title" label={props.translate('title')} />
      <EditButton {...props} />
    </Datagrid>
  </List>
));

const CourseTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.title }) : ''}</span>
));

export const CourseCreate = t((props) => (
  <Create {...props} title={props.translate('create.item', { item: props.translate('academy.course') })}>
    <SimpleForm>
      <TextInput source="title" options={{ fullWidth: true }} label={props.translate('title')} />
      <TextInput source="subtitle" options={{ fullWidth: true }} label={props.translate('subtitle')} />

      <ReferenceInput {...props} format={(courseCategory) => courseCategory && courseCategory._id} source="courseCategory" label={props.translate('academy.courseCategory')} reference="courseCategory" allowEmpty>
        <SelectInput optionText={`name.${props.locale}`} optionValue="_id" />
      </ReferenceInput>

      <ReferenceArrayInput style={styles.sectionMargin} source="positions" reference="positions" label={props.translate('position')} allowEmpty>
        <SelectArrayInput
          source="positions"
          optionText={(choice) => getTranslationByLocale(choice.name, props.locale)}
          options={{ fullWidth: true, errorText: props.translate('positionsHintText'), errorStyle: { color: 'darkslategrey', bottom: '-20px' }, floatingLabelFocusStyle: { color: 'darkslategrey' } }}
        />
      </ReferenceArrayInput>
      <TextInput source="evaluationForm" options={{ fullWidth: true }} />
      <RichTextInput source="description" label={props.translate('academy.description')} />
      <CourseMomentsInput source="courseMoment" />
      <Divider style={{ margin: '10px, 0, 10px, 0' }} />

    </SimpleForm>
  </Create>
));

export const CourseEdit = t((props) => (
  <Edit title={<CourseTitle />} {...props}>
    <SimpleForm redirect="edit">

      <TextInput source="title" options={{ fullWidth: true }} label={props.translate('title')} />
      <TextInput source="subtitle" options={{ fullWidth: true }} label={props.translate('subtitle')} />

      <ReferenceInput {...props} format={(courseCategory) => courseCategory && courseCategory._id} source="courseCategory" label={props.translate('academy.courseCategory')} reference="courseCategory" allowEmpty>
        <SelectInput optionText={`name.${props.locale}`} optionValue="_id" />
      </ReferenceInput>

      <ReferenceArrayInput style={styles.sectionMargin} source="positions" reference="positions" label={props.translate('position')} allowEmpty>
        <SelectArrayInput
          source="positions"
          optionText={(choice) => getTranslationByLocale(choice.name, props.locale)}
          options={{ fullWidth: true, errorText: props.translate('positionsHintText'), errorStyle: { color: 'darkslategrey', bottom: '-20px' }, floatingLabelFocusStyle: { color: 'darkslategrey' } }}
        />
      </ReferenceArrayInput>
      <TextInput source="evaluationForm" options={{ fullWidth: true }} />
      <RichTextInput source="description" label={props.translate('academy.description')} />

      <CourseMomentsInput source="courseMoment" />

      <UrlParamsLinkButton
        resourceType="questions"
        action="create"
        fields="courseId, courseName"
        values="_id, title"
        style={anchorStyle}
      >
        <FlatButton
          primary
          label={props.translate('create.item', { item: props.translate('academy.question') })}
          icon={<CreateIcon />}
        />
      </UrlParamsLinkButton>

      <FunctionField
        label={props.translate('academy.questions')}
        render={(record) =>
          record.questions && record.questions.map((question) => (
            <MaterialList>
              <QuestionList question={{ ...question }} course={{ ...record }} {...props} />
            </MaterialList>)
          )
        }
      />
    </SimpleForm>
  </Edit>
));

export const CourseShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
    </SimpleShowLayout>
  </Show>
);

export const QuestionList = ({ question: { question: questionTitle, _id: questionId }, ...props }) => (
  <ListItem
    primaryText={questionTitle}
    primaryTogglesNestedList
    nestedItems={[
      <ListItem style={styles.NestedListItem} key={questionId} className="ListItemParent">
        <MenuListItemLink
          to={{ pathname: `/questions/${questionId}`, state: props.location.pathname }}
          onClick={() => {}}
          style={styles.Button}
        >
          <EditIcon style={styles.Icons} />
          <div>
            {props.translate('edit.item', { item: props.translate('academy.question') }).toUpperCase()}
          </div>
        </MenuListItemLink>
      </ListItem>,
    ]}
  >
  </ListItem>
);
